import { Link } from "react-router-dom"

export default function HeaderLogo() {
  return (
    <header className="header-nav">
      <nav className="navbar navbar-expand-lg navbar-light">
        <div className="container-fluid">
          <Link className="navbar-brand" to="/">
            <img src={`${process.env.PUBLIC_URL}/img/logo_extended.svg`} alt="Logo" className="header-logo" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarScroll"
            aria-controls="navbarScroll"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarScroll">
            <div className="ms-auto">
              <ul className="navbar-nav me-auto my-2 my-lg-0 navbar-nav-scroll align-items-lg-center">
                <li className="nav-item">
                  <Link className="nav-link active" to="/domande-frequenti">
                    Come funziona?
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link active" to="/negozi">
                    Attivit&agrave;
                  </Link>
                </li>
                <li className="nav-item">
                  <a className="nav-link active" href={`${process.env.REACT_APP_DASHBOARD_URL}`}>
                    <button className="d-none d-lg-block btn btn-green-outline">Sei un commerciante?</button>
                    <span className="d-lg-none">Sei un commerciante?</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </header>
  )
}
